import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	Button,
} from '@mui/material';

const ConfirmDialog = ({
	open,
	title = 'Confirm',
	message,
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	confirmColor = 'error',
	onConfirm,
	onCancel,
}) => (
	<Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
		<DialogTitle>{title}</DialogTitle>
		<DialogContent>
			<DialogContentText>{message}</DialogContentText>
		</DialogContent>
		<DialogActions sx={{ px: 3, pb: 2 }}>
			<Button onClick={onCancel}>{cancelText}</Button>
			<Button onClick={onConfirm} color={confirmColor} variant="contained">
				{confirmText}
			</Button>
		</DialogActions>
	</Dialog>
);

export default ConfirmDialog;
